import { FC } from 'react';

export type ToggleProps = {
  checked: boolean;
  toggle: () => void;
};

export const Toggle: FC<ToggleProps> = ({ checked, toggle }) => {
  return (
    <label className="inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        value=""
        className="sr-only peer"
        checked={checked}
        onChange={() => toggle()}
      />
      <div
        className="
          relative w-[36px] h-[20px] bg-grey-plain dark:bg-grey-main  
          rounded-full peer-checked:after:translate-x-full 
          rtl:peer-checked:after:-translate-x-full 
          peer-checked:after:border-white after:content-[''] 
          after:absolute after:top-0.5 after:start-[2px] 
          after:bg-white after:shadow-md after:rounded-full after:h-4 after:w-4 
          after:transition-all
          peer-checked:bg-positive peer-checked:hover:bg-positive-hover
          peer-checked:bg-positive-hover peer-checked:hover:bg-hover"
      ></div>
    </label>
  );
};
